<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin                                                                         -->
        <v-card v-if="proceed_flag" align="center" justify="center" class="box">
            <!-- <v-card-title> Add Visitor </v-card-title> -->
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Visitor E-Pass</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <v-btn class="button" @click="generatePDF()">GET PDF </v-btn> -->
            <!-- <v-btn class="button" @click="exportToPDF">GET PDF</v-btn> -->

            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
                <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>

            <!-- <v-card-text> -->

            <!-- content for ui -->
            <v-card class="box1">
                <div ref="document">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-img style="width: 250px; height: 140px" class="shrink" contain :src="logo"></v-img>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="4" md="4"></v-col>
                        <v-col cols="12" md="4" sm="4">
                            <qrcode-vue v-if="walkin_visitor_epass_url != null" :value="walkin_visitor_epass_url"
                                :size="150" level="H" />
                        </v-col>
                        <v-col cols="12" md="4" sm="4">

                        </v-col>
                    </v-row>
                    <!-- simple table  -->

                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table id="page">
                            <tbody class="tablebody">
                                <tr>
                                    <td>Name</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.visitor_data.visitor_name }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mobile No</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.visitor_data.visitor_mobile }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.visitor_data.visitor_address }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>purpose</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.purpose }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Whom To Contact</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.vs_whom_to }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>From Date</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.fromdate }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>To Date</td>
                                    <td class="tdata2">
                                        {{ visitor_visit_data.todate }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-row dense justify="center">
                        <br />
                        <span class="instruction"> <b> Instructions to Visitor </b></span><br /><br />
                        <span><b> 1.</b>Every visitor should check out before existing school
                            campus.</span><br />
                        <span><b>2.</b>Visitor should not stay more than required in school
                            campus.</span><br /><br />
                    </v-row>
                </div>
            </v-card>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

// import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
export default {
    components: {
        QrcodeVue,
        VueHtml2pdf,
    },
    data: () => ({
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        ///////////////////////////////////////////////
        logo: null,
        proceed_flag: false,
        visitor_visit_data: null,
        walkin_visitor_epass_url: null,
        photo: null,

        ///////////////////
        htmlToPdfOptions: {
            margin: 10,
            padding: 20,

            filename: `hehehe.pdf`,

            image: {
                type: "jpeg",
                quality: 0.98,
            },

            enableLinks: false,

            html2canvas: {
                scale: 1,
                useCORS: true,
            },

            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "landscape",
            },
        },
        progress: 0,
    }),

    mounted() {
        // this.save_edit = "Add Myself";

        console.log("params", this.$route.query.o); // outputs 'yay'
        console.log("params", this.$route.query.t); // outputs 'yay'
        //  return
        const formdata = {
            o: this.$route.query.o,
            t: this.$route.query.t,
            mobile: this.$route.query.mob,
            vspid: this.$route.query.vspid,
        };
        //alert(formdata.o)
        this.overlay = true;
        axios
            .post("/visitorManagement/getEpassforvisitor", formdata)
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.overlay = false;
                    this.logo = res.data.logo;
                    this.visitor_visit_data = res.data.visitor_person_data;
                    this.walkin_visitor_epass_url = res.data.walkin_visitor_epass_url_for_mail;
                    this.proceed_flag = true;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                    this.overlay = false;
                }
                this.overlay = false;
            })
            .catch((error) => {
                this.onerror(error);
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
                // this.selected_date=""
            });
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        async exportToPDF() {
            console.log("in pdf");
            await html2pdf(this.$refs.document, {
                enableLinks: false,
                margin: 0,
                padding: 0,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 1 },
                html2canvas: { scale: 1, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
            });
            console.log("out of pdf");
        },
        // pdf gener
        onProgress(event) {
            console.log(`Processed: ${event} / 100`);
        },
        hasGenerated() {
            alert("PDF generated successfully!");
        },
        generatePDF() {
            this.$refs.html2Pdf.generatePdf();
            // html2pdf(this.$refs.document, {
            //   margin: 2,
            //   filename: "Epass.pdf",
            //   image: { type: "jpg", quality: 0.98 },
            //   html2canvas: { dpi: 192, letterRendering: true },
            //   jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            // });
        },
        // validation code
        // validation code end
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        ///////////////////////////


    },
};
</script>

<style scoped>
.alert {
    /* padding: 5px 10px; */
    /* border: 1px solid #ff72728a; */
    display: inline-block;
    color: #f30808;
    /* border-radius: 4px; */
}

.box1 {
    background-color: white !important;
    /* margin: 8px !important;
  padding: 8px; */
    border: 2px solid #8360c3 !important;
    width: 45%;
    /* margin-left: 28%; */
    margin: 3%;
}

#page tr,
td {
    /* padding: 0;  */
    /* margin-left: 0px; */
    font-size: large;
    text-align: left;
}

.tdata2 {
    font-weight: bolder;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    margin: 0.1rem !important;
    padding: 0.1rem !important;
    font-size: small;
}

.vi-img {
    border-radius: 22%;
    /*   
  max-width: 200px;
  max-height: 200px; */
}

/* mobile view */
@media only screen and (max-width: 600px) {
    .box1 {
        background-color: white !important;
        /* margin: 8px !important;
  padding: 8px; */
        border: 2px solid #8360c3 !important;
        width: 95%;
        /* margin-left: 28%; */
        margin: 3%;
    }
}

@media print {
    .box1 {
        width: 100%;
        margin: 0;
    }

    .instruction {
        /* margin-bottom: 10px; */
        width: 50%;
    }

    .card {
        border: none !important;
        font-size: large !important;
    }

    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    tr,
    th,
    td {
        font-size: large !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        orientation: portrait;
        /* orientation: landscape; */
        /* size: 12in 20in; */
    }

    thead {
        font-weight: bold !important;
    }

    table,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: none !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
    }
}
</style>